export default __webpack_public_path__ + "static/RegistartionBg-1cbd455652f66bc4c2ebbc1b888bc667.png";